import Records from '../ItemPopup/Records';
import Achievements from '../ItemPopup/Achievements';
import Photos from '../Uploads/Photos';
import PhotosWithoutId from '../Uploads/PhotosWithoutId';
const ItemCommonBottom = ({ itemPopup, itemPopupAchievements, handleItemPopupAchievements, Section, setImageUploadList, imageUploadList }) => {
    return (
        <div>
            {Section != 'Winter Grazing' && Section != 'Community & Cultural Significance' &&
                <>
                    <Records refid={itemPopup.itemId}></Records> <br />
                    <Achievements itemPopupAchievements={itemPopupAchievements} handleItemPopupAchievements={handleItemPopupAchievements}></Achievements><br />
                </>
            }
            <PhotosWithoutId setImageUploadList={setImageUploadList} imageUploadList={imageUploadList} disabledMode={false} refId={itemPopup.itemId} header="Photo" uploadType="Item" ></PhotosWithoutId>
        </div>
    )
}
export default ItemCommonBottom